var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('ScreenDialog',{ref:"screenDialog"}),(_vm.$isMobile && !_vm.isLandscape)?_c('div',{staticClass:"orientation-prompt"},[_c('p',[_vm._v("请将设备旋转至横屏以获得最佳体验。")])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }